export enum ControlTerminalMode {
  LIVE = 'LIVE',

  PREVIEW = 'PREVIEW',
}
